export default "/static/media/cdaba10c8985f42149152e14615c5a88.png";